import type * as Types from '../../../../types';

export type ComponentOption =
  | {
      type: 'input';
    }
  | {
      // Static options, corresponding to general selectors
      type: 'static';
      value: { display: string; value: string }[];
    }
  | {
      // Corresponding to the search selector,
      type: 'search';
      value: string;
      searchBackfill: boolean;
    };

export function getComponentConfig(meta: Types.DimensionFieldMeta): ComponentOption {
  const hasOptions = Array.isArray(meta.values) && meta.values.length > 0;

  if (hasOptions) {
    return {
      type: 'static',
      value: meta.values.map((option: any) => ({ display: option.name, value: option.value })),
    };
  } else if (meta?.urls?.value) {
    return {
      type: 'search',
      value: meta.urls.value,
      searchBackfill: !meta.autocompletion_only,
    };
  }

  return {
    type: 'input',
  };
}

export function getRuleValuesHash(value: Types.FilterRuleValuePair[]) {
  return value
    .map((it) => `${it.value}_${it.display}`)
    .toSorted()
    .toString();
}

export function compareRuleValues(a: Types.FilterRuleValuePair[], b: Types.FilterRuleValuePair[]) {
  return a.length === b.length && getRuleValuesHash(a) === getRuleValuesHash(b);
}

export function getRuleValuesTitle(
  values: { label?: string | React.ReactNode; display?: string }[],
) {
  return values
    .filter((it) => it.label || it.display)
    .map((it) => `"${it.label || it.display}"`)
    .join(' or ');
}

// Keep the original dropdownRender for future use
// dropdownRender={(menu) => {
//   if (!multiple) return menu;

//   return (
//     <>
//       {menu}
//       <Divider style={{ margin: '4px 0' }} />
//       <Space
//         style={{
//           display: 'flex',
//           justifyContent: 'flex-end',
//           margin: '8px 4px 4px',
//         }}
//       >
//         <Button
//           size="small"
//           onClick={() => {
//             if (!Array.isArray(value) || !value.length) return;
//             onChange?.(value.map((it) => ({ value: it.value, display: it.label })));
//           }}
//         >
//           Apply
//         </Button>
//       </Space>
//     </>
//   );
// }}
